/**
 * Copyright (c) 2024-2026 Creative Agentics Limited. All rights reserved.
 * Proprietary and confidential.
 *
 * SOURCE OF FUNDS AND SOURCE OF WEALTH EVIDENCE IS NEVER DROPPED BY THE DRAFTING
 * PASS (v1_964).
 *
 * Glass Bottle Management Limited (677a4d19, 01/10/2026): the drafting pass left
 * out "evidence of how Glass Bottle Management Limited acquired the Bitcoin and
 * Ethereum it holds", and the round send closed it as left out of the request
 * (planRoundSend). The drafting pass is a model judgement; nothing put the item
 * back. v1_961 made the same rule hold in code for the proportionality pass, for
 * source of funds evidence only. This adds source of wealth evidence and applies
 * both to the request pipeline: a protected item the draft leaves out is added
 * back to the draft, and the send never closes it.
 *
 * Only requests for the evidence itself are matched, as in v1_961. Narrative
 * questions are judged as before. Personal source of wealth for a named person
 * is collected through the separate source of wealth interview (the drafting
 * prompt drops it from the client request), so it is not protected here.
 */

// The same expression as api/_proportionality.js (v1_961); the harness checks
// the two stay identical.
export const SOF_EVIDENCE_RE = /\bbank statements?\b|\bstatements? (for|of|from) [^.]{0,80}\baccount\b|\bproof of (funds|payment)\b|\bbank(ing)? (records?|confirmation|reference letter)\b|\b(transfers?|payments?|subscriptions?|capital injections?)\b[^.]{0,80}\b(bank statements?|banking records?|statements?)\b/i;

const ASSET = String.raw`(?:crypto\w*|bitcoin|btc|ether(?:eum)?|eth|usdt|usdc|stablecoins?|digital assets?|virtual assets?|tokens?|coins?|wallet holdings?|holdings?|assets?|wealth|portfolio|investments?|shares?|propert(?:y|ies)|capital)`;
const ACQ = String.raw`(?:acquir\w*|acquisition|obtain\w*|accumulat\w*|built up|came to (?:hold|own)|purchas\w*|bought|mined|minted|received|origin|provenance|derived)`;
const EVID = String.raw`(?:evidence|evidenc\w+|documents?|documentation|records?|statements?|histor(?:y|ies)|proof|receipts?|invoices?|contracts?|agreements?|confirmation|trade (?:confirmations?|logs?)|transaction (?:logs?|exports?|reports?))`;
export const SOW_EVIDENCE_RE = new RegExp(
  String.raw`\bsource of wealth\b[^.]{0,40}\b${EVID}\b|\b${EVID}\b[^.]{0,40}\bsource of wealth\b` +
  String.raw`|\b${EVID}\b[^.]{0,120}\b${ACQ}\b[^.]{0,80}\b${ASSET}\b` +
  String.raw`|\b${EVID}\b[^.]{0,120}\b${ASSET}\b[^.]{0,80}\b${ACQ}\b` +
  String.raw`|\b(?:origin|provenance) of (?:the )?(?:[\w']+ ){0,3}${ASSET}\b`, 'i');

// Personal source of wealth of a named individual: the separate interview.
const PERSONAL_RE = /\b(personal|individual'?s?|his|her)\b[^.]{0,40}\b(wealth|assets?|savings|income)\b|\b(wealth|assets?)\b[^.]{0,20}\b(personally|of (?:the |each )?(?:director|shareholder|ubo|beneficial owner)s?)\b/i;

export function isSourceOfWealthEvidence(label) {
  return SOW_EVIDENCE_RE.test(String(label == null ? '' : label));
}
export function isProtectedEvidence(label) {
  const t = String(label == null ? '' : label);
  if (PERSONAL_RE.test(t)) return false;
  return SOF_EVIDENCE_RE.test(t) || SOW_EVIDENCE_RE.test(t);
}

export const KEPT_OPEN_NOTE = 'Kept open: source of funds or source of wealth evidence is never closed by the drafting pass';
